import axios from 'axios';
import { IPatient } from 'entities/Patient/Patient.models';

const basePath = '/patients';

export const patientService = {
  getPatientByEventId: (eventId: number): Promise<IPatient> => axios.get(`${basePath}/by-event/${eventId}`),
};
